export const sales = {
  title: 'Értékesítés',
  subtitle: 'Point of Sale rendszer',
  pos: 'Kassza',
  
  warehouse: {
    title: 'Értékesítési hely kiválasztása',
    all: 'Mind',
    allDescription: 'Összes raktár/üzlet készleteit mutatja',
    unknown: 'Ismeretlen raktár',
    storage: 'Raktár'
  },
  
  categories: {
    title: 'Kategóriák',
    all: 'Összes kategória',
    subcategories: 'Alkategóriák',
    clearFilters: 'Szűrők törlése'
  },
  
  products: {
    title: 'Termékek',
    search: 'Termék keresése (név, kód)...',
    loadingOrAddRequired: 'Termékek betöltése vagy hozzáadása szükséges',
    clearFilters: 'Szűrők törlése',
    noImage: 'Nincs kép',
    service: 'Szolgáltatás',
    inactive: 'Inaktív',
    nextPage: 'Következő oldal',
    previousPage: 'Előző oldal'
  },
  
  cart: {
    title: 'Kosár',
    empty: 'Üres kosár',
    summary: 'Összesítő',
    netAmount: 'Nettó összeg',
    vat: 'ÁFA',
    totalAmount: 'Fizetendő',
    paymentMethod: 'Fizetési mód',
    cash: 'Készpénz',
    card: 'Bankkártya',
    transfer: 'Átutalás',
    sellButton: 'Értékesítés és számla kiállítása'
  },
  
  stock: {
    outOfStock: 'Nincs készlet',
    insufficientStock: 'Nincs elegendő készlet',
    stockRequired: 'Raktár választása szükséges',
    available: 'db áll rendelkezésre',
    inStock: 'Van készlet a termékből',
    transferable: 'Átkérhető készlet',
    noStock: 'Nincs készlet',
    transfer: {
      title: 'Raktárközi átkérés',
      request: 'Átkérés',
      sent: 'Átkérés elküldve',
      success: 'átkérése megtörtént'
    }
  },
  
  browsing: {
    title: 'Böngészés mód',
    description: 'Most az összes raktár készleteit látod.',
    instruction: 'Értékesítéshez válassz ki egy konkrét raktárat a fenti listából.',
    legend: {
      green: 'Zöld = Van készlet a termékből',
      orange: 'Narancssárga = Átkérhető készlet', 
      red: 'Piros = Nincs készlet'
    }
  },
  
  messages: {
    success: {
      saleCompleted: 'Értékesítés befejezve',
      saleRecorded: 'Az értékesítés sikeresen rögzítve lett a rendszerben!',
      invoiceGenerated: 'Számla kiállítva',
      stockTransferSent: 'Átkérés elküldve'
    },
    warning: {
      warehouseRequired: 'Raktár választása szükséges',
      selectWarehouse: 'Válassz egy konkrét raktárat az értékesítéshez.',
      insufficientStock: 'Nincs elegendő készlet',
      onlyAvailable: 'Csak {{count}} db áll rendelkezésre ebben a raktárban.',
      missingStock: 'Hiányzó készlet: {{product}}'
    },
    error: {
      noStock: 'Nincs készlet',
      noStockAnyWarehouse: 'Ez a termék nincs készleten egyik raktárban sem.',
      invoiceError: 'Számla kiállítás hiba',
      invoiceFailed: 'Nem sikerült kiállítani a számlát',
      unknownError: 'Ismeretlen hiba'
    }
  },
  
  customer: {
    default: 'Vevő',
    country: 'Magyarország'
  },
  
  currency: 'HUF',
  unit: 'db'
}; 